<div class="flex items-start" *ngIf="!createNewSelected">
	<div class="flex flex-1 flex-col bg-grey-lightest p-6 rounded-l-2xl">
		<h4 class="">Add documents</h4>
		<p class="mb-10 text-sm">Add 1 or more template documents to the matter</p>
		<ng-container>
			<app-input
				[startIcon]="ICON.SEARCH"
				placeholder="Search documents"
				[(ngModel)]="documentFilter"
				(ngModelChange)="filterDocuments()"
			></app-input>
			<div
				class="flex flex-col overflow-y-auto overflow-hidden h-80 p-5 mt-5 border rounded-xl border-grey-light bg-white"
			>
				<div
					class="bg-grey-lightest rounded-xl py-2 px-10 cursor-pointer hover:bg-grey-veryLight hover:shadow-md mb-5 relative"
					[class.selected]="getSelected(document.id)"
					*ngFor="let document of filteredBusinessDocuments"
					(click)="toggleSelectedDocument(document)"
				>
					<app-icon
						[icon]="ICON.CHECK"
						*ngIf="getSelected(document.id)"
						class="absolute left-3 text-green font-bold text-lg"
					></app-icon>
					<span>{{ document.title }}</span>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="w-80 p-6">
		<h4>Selected documents</h4>
		<p
			*ngIf="!objectKeys(selectedDocuments)?.length"
			class="text-sm text-grey-light"
		>
			No selected documents
		</p>
		<div class="max-h-[440px] overflow-y-auto">
			<div
				*ngFor="let docId of objectKeys(selectedDocuments)"
				class="mb-3 overflow-y-auto"
			>
				<div class="text-sm flex justify-between items-center">
					<p>{{ selectedDocuments[docId].title }}</p>
					<app-icon
						[icon]="ICON.CLOSE"
						(click)="toggleSelectedDocument(selectedDocuments[docId])"
						class="cursor-pointer text-grey-light"
					></app-icon>
				</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="createNewSelected" class="p-6">
	<div class="flex flex-1 flex-col">
		<h4 class="">Add documents</h4>
		<p class="mb-5 text-sm" *ngIf="createNewSelected">
			Add a new document to the matter
		</p>
		<div
			(click)="selectAddNew()"
			[class.selected]="createNewSelected"
			class="bg-grey-veryLight rounded-xl hover:shadow-md cursor-pointer p-2"
		>
			<div class="font-bold">Blank document</div>
			<div *ngIf="createNewSelected" [@openClose]>
				<app-input
					label="Title"
					placeholder="New document title"
					[(ngModel)]="newDocumentName"
				></app-input>
			</div>
		</div>
	</div>
</div>

<div class="flex justify-between w-full">
	<div
		[class.bg-grey-lightest]="!createNewSelected"
		class="p-6 flex-1 rounded-bl-2xl"
	>
		<app-button btn="tertiary" (click)="cancelModal()" size="small"
			>Cancel</app-button
		>
	</div>
	<div class="w-80 flex justify-end p-6">
		<app-button
			size="small"
			(click)="createDocument()"
			[disabled]="
				!createNewSelected && objectKeys(selectedDocuments)?.length === 0
			"
			[loading]="creating"
			>Create
			{{ !createNewSelected ? ' (' + documentTotals + ')' : '' }}</app-button
		>
	</div>
</div>

<atomic-message-bar
	*ngIf="selectADocumentMessage"
	type="warn"
	class="mt-3"
	[@openClose]
	>Select a document before continuing.</atomic-message-bar
>
<atomic-message-bar *ngIf="error" type="warn" class="mt-3" [@openClose]
	>There was an error creating the document. Please try
	again.</atomic-message-bar
>
